
import { Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgOptimizedImage } from '@angular/common';
import { ToasterService } from '../../services/toaster.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { chat } from '../../../model/chat.model';
import { AssistService } from '../../../services/assist.service';
import { RuleAssistModel } from '../../../model/assist.model';
import { finalize } from 'rxjs';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rule-assist-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    NgOptimizedImage
],
  providers: [ToasterService, TranslatePipe],
  templateUrl: './rule-assist-modal.component.html',
  styleUrl: './rule-assist-modal.component.scss'
})
export class RuleAssistModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<boolean>();
  @Input() ruleAssistQuestionObject!: chat;
  userRating: number = 0;
  form!: FormGroup;
  recording: boolean = false;
  audioUrl: string | undefined;
  timer: ReturnType<typeof setInterval> | undefined;
  seconds: number = 0;
  minutes: number = 0;
  paused: boolean = false;
  isRecording: boolean = false;
  protected readonly submitting = signal(false);
  protected readonly submitted = signal(false);
  private fb = inject(FormBuilder);
  private toasterService = inject(ToasterService);
  private _assistService = inject(AssistService);
  private _translatePipe = inject(TranslatePipe);

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      comment: ["", [Validators.required]]
    });
  }

  onRatingUpdated(rating: number) {
    this.userRating = rating;
    this.form.patchValue({ rating });
  }

  close() {
    this.form.reset();
    this.closeModal.emit();
  }

  submit() {
    if (this.form.invalid) {
      return this.toasterService.warning(this._translatePipe.transform("RequiredValidation"), this._translatePipe.transform("Warning"));
    }
    // if(!this.form.value.message && !this.form.value.audioFeedBack){
    //   return this.toasterService.warning("Please give feedback in audio or text message.");
    // }
    const trimmedMessage = this.form.value.comment.trim();

    if (!trimmedMessage) {
      return this.toasterService.warning(this._translatePipe.transform("FeedbackRequired"), this._translatePipe.transform("Warning"));
    }
    // if(!this.form.value.message){
    //   return this.toasterService.warning("Please add a feedback.");
    // }

    this.submitting.set(true);
    const data: RuleAssistModel = {
      email: this.form.value.email,
      comment: this.form.value.comment,
      questionId: this.ruleAssistQuestionObject.id,
      answerId: this.ruleAssistQuestionObject.answerId
    }
    this._assistService.ruleAssist(data).pipe(
      finalize(() => this.submitting.set(false))
    ).subscribe({
      next: (res => {
        this.toasterService.success(this._translatePipe.transform("ruleAssistSuccessMessage"), this._translatePipe.transform("Success"));
        this.submitted.set(true);
        this.closeModal.emit();
      })
    })
  }
}
